export enum TeamTypeSettingsRequestBy {
	TeamMembers,
	TeamOwners,
	TeamContactPersons,
	Archivaris,
	TeamManagers
}
